import { Switch } from '@/components/ui/switch';
import { EngagementAdminConfig } from '@/generated/graphql';
import { configChanged } from '@/providers/AdminEngagementProvider/actions';
import { useAdminEngagementContext } from '@/providers/AdminEngagementProvider/AdminEngagementContext';
import { BooleanKeys } from '@/types/common';

export function BooleanConfigInput<TConfig extends EngagementAdminConfig>({
  configKey,
}: {
  configKey: BooleanKeys<TConfig>;
}) {
  const { state, dispatch } = useAdminEngagementContext();
  const value = (state.config as TConfig)?.[configKey] ?? false;

  return (
    <Switch
      checked={!!value}
      onCheckedChange={(checked) =>
        dispatch(configChanged({ config: { [configKey]: checked } }))
      }
    />
  );
}
